import { render } from "./area-echarts.vue?vue&type=template&id=3c7e9fa2&scoped=true"
import script from "./area-echarts.vue?vue&type=script&lang=js"
export * from "./area-echarts.vue?vue&type=script&lang=js"

import "./area-echarts.vue?vue&type=style&index=0&id=3c7e9fa2&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7e9fa2"]])

export default __exports__